const rankings = [
  { rank: 1, title: '剑尊归来', genre: '热血 / 武侠', heat: '985,632', trend: 'up' },
  { rank: 2, title: '斗破苍穹', genre: '玄幻 / 热血', heat: '954,210', trend: 'up' },
  { rank: 3, title: '我独自升级', genre: '奇幻 / 冒险', heat: '876,421', trend: 'stable' },
  { rank: 4, title: '女神降临', genre: '恋爱 / 校园', heat: '798,563', trend: 'down' },
  { rank: 5, title: '暗黑之城', genre: '悬疑 / 奇幻', heat: '745,210', trend: 'up' },
  { rank: 6, title: '全职猎人', genre: '冒险 / 热血', heat: '698,547', trend: 'stable' },
  { rank: 7, title: '甜蜜暴击', genre: '恋爱 / 日常', heat: '652,103', trend: 'up' },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-accent-400 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫网实时热度排行，看看大家都在追哪些作品
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          {rankings.map((item, i) => (
            <a
              key={i}
              href={`#ranking`}
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 py-3.5 px-4 border-b border-background-100 last:border-b-0 group cursor-pointer hover:bg-background-100/50 transition-colors rounded-lg"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </p>
                <p className="text-xs text-foreground-500">{item.genre}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-accent-500 font-semibold whitespace-nowrap">
                  {item.heat}
                </span>
                {item.trend === 'up' && (
                  <span className="w-5 h-5 flex items-center justify-center text-green-500">
                    <i className="ri-arrow-up-s-fill text-xs"></i>
                  </span>
                )}
                {item.trend === 'down' && (
                  <span className="w-5 h-5 flex items-center justify-center text-red-400">
                    <i className="ri-arrow-down-s-fill text-xs"></i>
                  </span>
                )}
                {item.trend === 'stable' && (
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                    <i className="ri-subtract-line text-xs"></i>
                  </span>
                )}
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-6">
          <a
            href={`#ranking`}
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors"
          >
            查看完整榜单
            <i className="ri-arrow-right-s-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}